import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate, useParams } from 'react-router-dom';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useParams();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'zh' : 'en';
    i18n.changeLanguage(newLang);
    navigate(`/landing-page/${newLang}`);
  };

  return (
      <div className="flex items-center space-x-2">
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="top-4 right-4 z-50 flex items-center gap-2 text-black hover:text-accent"
    >
      <Globe className="h-5 w-5" />
      {i18n.language === 'en' ? '切换中文' : 'Switch to English'}
    </Button>
      </div>
  );
};